export default {"src":"/_next/static/media/busd.e8bb5032.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};